'use client';
import useNavigate from '@/hooks/useNavigate';
import { ToastContext } from '@/pagesComponents/Layout';
import * as achatsService from '@/services/achats';
import Errors from '@/services/errors';
import { useContext, useEffect } from 'react';

const MonerisCheckout = ({ model, achatResult, setAchatResultState }) => {
  let errorShown = false;
  const navigate = useNavigate();
  const literals = {
    MonerisCheckout: 'monerisCheckout',
  };
  const updateToast = useContext(ToastContext);

  function initMonerisPaiementCheckout () {
    const env = achatResult.data.monerisEnv;
    //Init Moneris checkout page
    if (!window.myCheckout) {
      /* eslint-disable */
      window.myCheckout = new monerisCheckout();

      //Settings callback functions
      window.myCheckout.setCallback('page_loaded', monerisPageIsLoaded);
      window.myCheckout.setCallback('cancel_transaction', monerisCancelTransaction);
      window.myCheckout.setCallback('error_event', monerisErrorHandler);
      window.myCheckout.setCallback('payment_complete', monerisPaymentComplete);

      window.myCheckout.setMode(env);
      window.myCheckout.setCheckoutDiv(literals.MonerisCheckout);
    }

    window.myCheckout.startCheckout(achatResult.data.ticketID);
  }

  function monerisPageIsLoaded (data) {
    console.info('Page loaded', data);
  }

  async function monerisCancelTransaction (data) {
    const response = await achatsService.monerisCancelTransaction(achatResult.data.orderId);

    if (response !== 'OK') {
      console.info('Moneris cancel transaction response', response);
      alert('Erreur - Annulation de la transaction \n\n' + response);
    }

    setAchatResultState(null);
  }

  function monerisErrorHandler (err) {
    console.error('Moneris error', err);
    alert('Une erreur s\'est produite durant le processus de paiement');
  }

  async function monerisPaymentComplete (data) {
    try {
      window.myCheckout.closeCheckout();
      // payment successfull display a loader while we generate cards.
      document.getElementById('spinner').classList.remove('d-none');
      // hide CHeckout outerDiv
      document.getElementById('moneris').classList.add('d-none');
      document.getElementById('outerDiv').classList.add('d-none');
      const response = await achatsService.monerisCompleteTransaction(
        achatResult.data.orderId,
        achatResult.data.ticketID
      );
      if (response !== 'OK' && response.type !== 'success') {
        console.info('Moneris cancel transaction response', response);
        if (!errorShown) {
          alert('Désolé. Votre paiement a été refusé. \r\nVeuillez réessayer de nouveau ou contacter le service a la clientèle.');
          errorShown = true;
        }
        document.getElementById('spinner').classList.add('d-none');
        return;
      }
      // hide spinner again
      else setTimeout(() => navigate('/receipts?refresh=1&tirageId=' + model.tirage.id), 200);
    } catch (err) {
      console.error('GENERIC MONERIS ERROR', err);
      alert('Une erreur générique est survenue, svp contacter le service a la clientèle.');
    }
  }

  useEffect(() => {
    try {
      const script = document.createElement('script');
      script.src = achatResult.data.monerisScriptJsUrl;
      script.async = true;
      script.onload = () => initMonerisPaiementCheckout();
      document.getElementById(literals.MonerisCheckout).appendChild(script);
    } catch (err) {
      Errors.handleError(err, updateToast);
      console.error(err);
    }
  }, [model, achatResult]);

  useEffect(() => {
    return () => {
      delete window.myCheckout;

    };
  }, []);

  return (
    <div id={'moneris-checkout-section'}>
      <div className="">
        <div className="row g-0 ">
          <div id="spinner" className=" d-none full-screen  ">
            <div className="d-flex flex-column justify-content-center align-items-center h-100 w-100">
              <div className="spinner-border mb-5"></div>
              <div className="alert alert-info m-2">
                Nous avons reçu votre demande de paiement. Veuillez patienter pendant que nous la traitons.
              </div>
            </div>
          </div>
          <div id="moneris"></div>
          <div id="outerDiv" className="w-100 ">
            <div id={literals.MonerisCheckout} className="position-inherit"></div>
          </div>
        </div>
      </div>
    </div>
  );
};
export default MonerisCheckout;
